import TicketSection from "../common/TicketSection.jsx";
import SimpleTextArea from "../common/SimpleTextArea.jsx";
import React from "react";

export default props => {
  return (
    <>
      {/* EXPECTATIONS */}
      <TicketSection text = { props.expectations.name } compact = { props.eCompact } >
        <SimpleTextArea
          name   = { props.expectations.name }
          value  = { props.expectations.value }
          update = { props.expectations.update }
          index  = { props.index + 2 }
        />
      </TicketSection>
    </>
  );
}